(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["recomendation-block"] && !Shopify.designMode) return;
  try {
    (function () {

  /* ── 1. Dynamically load Swiper v11 (once) ── */
  function loadSwiper(cb) {
    if (window.Swiper) return cb();

    const css = document.createElement('link');
    css.rel  = 'stylesheet';
    css.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
    document.head.appendChild(css);

    const js  = document.createElement('script');
    js.src    = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
    js.onload = cb;
    document.head.appendChild(js);
  }

  /* ── 2. Init every un-initialised .ymal-swiper ── */
  function initSwipers() {
    document.querySelectorAll('.ymal-swiper:not([data-swiper-ready])').forEach(function (el) {
      el.setAttribute('data-swiper-ready', 'true');

      new Swiper(el, {
        slidesPerView : 2,
        spaceBetween  : 24,
     
        breakpoints: {
          0   : { slidesPerView: 1.2, spaceBetween: 16 },
          600 : { slidesPerView: 1.6, spaceBetween: 10 },
        },
      });
    });
  }


  
  

  /* ── 4. Boot ── */
  loadSwiper(function () {
    initSwipers();
    /* Re-init when theme editor reloads a section or selects a block */
    document.addEventListener('shopify:section:load',  initSwipers);
    document.addEventListener('shopify:block:select',  initSwipers);
  });

}());
  } catch(e) { console.error(e); }
})();

})();
